<template>
    <div class="contentBox">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: "contentBox"
};
</script>
<style lang="less">
    .contentBox{
        margin-left: 220px;
    }
</style>



// WEBPACK FOOTER //
// Content.vue?2dbb76eb